// src/app/public-home/publicHome.helpers.ts

import {
  ACCESS_REQUEST_API_BASE_URL,
} from "../../lib/environment";

import type {
  AccessRequestFormErrors,
  AccessRequestFormValues,
} from "./publicHome.types";

/* -------------------------------------------------------------------------- */
/* Validation                                                                 */
/* -------------------------------------------------------------------------- */

export function validateAccessRequest(
  values:
    AccessRequestFormValues,
): AccessRequestFormErrors {
  const errors:
    AccessRequestFormErrors = {};

  if (
    !values.name.trim()
  ) {
    errors.name =
      "Enter your name.";
  }

  const email =
    values.email.trim();

  if (
    !email
  ) {
    errors.email =
      "Enter your email.";
  } else if (
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
      email,
    )
  ) {
    errors.email =
      "Enter a valid email address.";
  }

  if (
    !values.role
  ) {
    errors.role =
      "Choose your role.";
  }

  return errors;
}

/* -------------------------------------------------------------------------- */
/* Access request                                                             */
/* -------------------------------------------------------------------------- */

export async function submitAccessRequest(
  values:
    AccessRequestFormValues,
): Promise<void> {
  if (
    !ACCESS_REQUEST_API_BASE_URL
  ) {
    throw new Error(
      "Access requests are not configured.",
    );
  }

  const response =
    await fetch(
      `${ACCESS_REQUEST_API_BASE_URL}/access-requests`,
      {
        method:
          "POST",

        headers: {
          "Content-Type":
            "application/json",
        },

        body:
          JSON.stringify({
            name:
              values.name.trim(),

            email:
              values.email.trim(),

            role:
              values.role,

            looksAfter:
              values.looksAfter.trim() ||
              undefined,
          }),
      },
    );

  if (
    !response.ok
  ) {
    throw new Error(
      "We couldn’t send your request. Try again.",
    );
  }
}